import styled from 'styled-components'

export const Container = styled.a`
    cursor: pointer;
`
export const LogoImg = styled.img``
